const SelectArrow = (props) => (
  <svg width={24} height={13} viewBox="0 0 24 13" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.817389 4.18735L10.0266 12.2818C11.1164 13.2394 12.8835 13.2394 13.9734 12.2818L23.1826 4.18735C24.2725 3.229 24.2725 1.67649 23.1826 0.718154C22.0927 -0.239385 20.3256 -0.239385 19.2358 0.718154L12 7.07873L4.76422 0.718154C3.67415 -0.239385 1.90724 -0.239385 0.817389 0.718154C-0.272463 1.67649 -0.272463 3.229 0.817389 4.18735Z"
      fill="#666666"
    />
  </svg>
);

export default SelectArrow;
